import { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import BakeasyCollapsibleTable, {
  CollapsibleTableHeadCell,
} from '../../components/tables/BakeasyCollapsibleTable';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyButton } from '../../components/buttons/BakeasyButton';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  clearSubCategoryState,
  fetchSubCategories,
  subCategoryState,
} from '../../redux_store/slices/subCategorySlice';
import {
  categoryState,
  clearCategoryState,
  fetchCategories,
} from '../../redux_store/slices/categorySlice';
import {
  BakeasyAutoCompleteCategoryA,
  BakeasyAutoCompleteProduct,
  BakeasyAutoCompleteSubCategoryA,
} from '../../components/dropdowns/BakeasyAutoComplete';
import {
  clearProductState,
  fetchProducts,
  productsState,
} from '../../redux_store/slices/productsSlice';
import {
  clearProductionReportState,
  getProductionReportById,
  productionReportState,
} from '../../redux_store/slices/productionReportSlice';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasyLargeHeadingValue from '../../components/lables/BakeasyLargeHeadingValue';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { BakeasySelectNew } from '../../components/dropdowns/BakeasySelect';

export const ProductionReportDetails: FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const [selectedCategory, setSelectedCategory] = useState<any>(undefined);
  const [selectedSubCategory, setSelectedSubCategory] =
    useState<any>(undefined);
  const [selectedProduct, setSelectedProduct] = useState<any>(undefined);
  const [selectedOrderId, setSelectedOrderId] = useState<any>('');
  const [selectedProductionReport, setSelectedProductionReport] =
    useState<any>('');
  const [productionReportHistory, setProductionReportHistory] = useState<any>();
  const [storeList, setStoreList] = useState<any[]>([]);
  const [byStoreTableHeaders, setByStoreTableHeaders] = useState<any[]>([]);

  const productionReport = ['By Product', 'By Store'];
  let _categoryState = useAppSelector(categoryState);
  let _subCategoryState = useAppSelector(subCategoryState);
  let _productsState = useAppSelector(productsState);
  let _orderIds = location?.state?.orderIds;
  const productionId = location?.state?.productionId;

  let { productsValue, filter } = useAppSelector(productionReportState);

  const reportTableHeaders: CollapsibleTableHeadCell[] = [
    { id: 'icon', label: '', width: '40px' },
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'categoryName', label: 'CATEGORY', width: '190px' },
    { id: 'subCategoryName', label: 'SUB_CATEGORY', width: '190px' },
    { id: 'store', label: 'STORE', width: '190px' },
    { id: 'totalOrder', label: 'TOTAL_ORDERS', width: '120px' },
    // { id: 'recipe', label: 'RECIPE', width: '120px' }
  ];

  const tableHeaders: CollapsibleTableHeadCell[] = [
    { id: 'storeName', label: 'STORE_NAME', width: '200px' },
    { id: 'totalOrders', label: 'TOTAL_ORDERS', width: '120px' },
    { id: 'orderId', label: 'ORDER_ID', width: '200px' },
  ];

  const checkValidity = (): boolean => {
    // if (!requestedDeliveryDate) {
    //   let msg = `${t('DUE_DATE')} ${t('IS_REQUIRED')}`;
    //   dispatch(showErrorSnackbar({ message: msg }));
    //   return false;
    // }
    if (!selectedProductionReport) {
      let msg = `${t('PRODUCTION_REPORT_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    return true;
  };

  async function filterDataPayload() {
    let payload: any = {
      productionId: productionId,
      // ...(selectedProductType &&
      //   selectedProductType !== 'All' && { productType: selectedProductType }),
      ...(selectedProductionReport && {
        productionReport: selectedProductionReport,
      }),
      // ...(selectedStatus && { status: selectedStatus }),
      ...(selectedOrderId !== '' && { orderId: selectedOrderId }),
      ...(selectedProduct && { productId: selectedProduct?._id }),
      ...(selectedCategory && { categoryName: selectedCategory?.categoryName }),
      ...(selectedSubCategory && {
        subCategoryName: selectedSubCategory?.subCategoryName,
      }),
    };
    return payload;
  }

  const handleGenerateClick = async () => {
    //setIsLoading(true);
    if (!checkValidity()) {
      return;
    }
    setProductionReportHistory([]);
    setStoreList([]);
    try {
      let payload = await filterDataPayload();
      await dispatch(getProductionReportById(payload));
    } catch (err) {}
  };

  useEffect(() => {
    dispatch(clearCategoryState());
    dispatch(clearSubCategoryState());
    dispatch(clearProductState());
    dispatch(fetchCategories({ page: 1, limit: 10 }));
  }, []);

  useEffect(() => {
    //let date: any = 'requestedDeliveryDate' in filter && filter?.requestedDeliveryDate;
    //'requestedDeliveryDate' in filter && setRequestedDeliveryDate(dayjs(new Date(date)));
    'productionReport' in filter &&
      setSelectedProductionReport(filter?.productionReport);
    // 'status' in filter && setSelectedStatus(filter?.status);
    //  'productType' in filter && setSelectedProductType(filter?.productType);
    'selectedCategory' in filter &&
      setSelectedCategory(filter?.selectedCategory);
  }, [filter]);

  useEffect(() => {
    if (productsValue?.length > 0) {
      let productionReport: any = '';
      let filteredData: React.SetStateAction<any[]> = [];
      let byStoreCollumn: any = [];

      if (selectedProductionReport === '' && 'productionReport' in filter) {
        productionReport = filter?.productionReport;
      } else {
        productionReport = selectedProductionReport;
      }

      if (productionReport === 'By Product') {
        try {
          filteredData = productsValue?.map((product: any) => ({
            icon: 'ICONN',
            onIconClick: () => {},
            productName: product?.productName,
            categoryName: product?.categoryName,
            subCategoryName: product?.subCategoryName,
            totalOrder: product?.totalOrder,
            store:
              product?.storeOrderDetails?.length > 1
                ? product?.storeOrderDetails[0].storeName + ',...'
                : product?.storeOrderDetails?.map((store: any) => {
                    return store?.storeName;
                  }),
            history:
              product?.storeOrderDetails?.map((store: any) => ({
                storeName: store?.storeName,
                totalOrders: store?.totalOrder,
                orderId: store?.orderId,
              })) || [],
            // recipe: (
            //   <BakeasyButton
            //     label={t('RECIPE')}
            //     onClick={(event: any) => {
            //       navigate('/recipeBuilder', { state: { productId: product?._id } });
            //     }}
            //   />
            // )
          }));

          setProductionReportHistory(filteredData);
        } catch (error) {
          console.error('Error', error);
          setProductionReportHistory([]);
          setStoreList([]);
        }
      } else if (productionReport === 'By Store') {
        filteredData = productsValue?.map((item: any) => {
          item?.storeOrderDetails?.forEach((storeItem: any) => {
            if (
              byStoreCollumn?.findIndex(
                (store: { id: any }) => store.id === storeItem.storeName
              ) === -1
            ) {
              byStoreCollumn.push({
                id: storeItem?.storeName,
                label: storeItem?.storeName,
                width: '120px',
              });
            }
          });

          let quantity = 0;
          const storeQuantity = byStoreCollumn.reduce(
            (acc: any, store: { label: any; id: any }) => {
              // quantity =
              //   item?.storeOrderDetails?.find((strQnt: any) => strQnt.storeName === store.label)
              //     ?.totalOrder || 0;
              // Filter storeOrderDetails to get all orders for the current store (not just the first match)
              const storeOrders = item?.storeOrderDetails?.filter(
                (strQnt: any) => strQnt.storeName === store.label
              );

              // Calculate the sum of totalOrders for the current store
              const quantity = storeOrders.reduce(
                (sum: any, order: any) => sum + (order?.totalOrder || 0),
                0
              );

              acc[store.id] = quantity;
              return acc;
            },
            {}
          );

          return {
            id: item._id,
            productName: item?.productName,
            ...storeQuantity,
            totalOrder: item?.totalOrder,
            // recipe: (
            //   <BakeasyButton
            //     label={t('RECIPEE')}
            //     size="small"
            //     onClick={(event: any) => {
            //       navigate('/recipeBuilder', { state: { productId: item?._id } });
            //     }}
            //   />
            // )
          };
        });

        byStoreCollumn?.length > 0 &&
          setByStoreTableHeaders([
            { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
            ...byStoreCollumn,
            { id: 'totalOrder', label: 'TOTAL_ORDERS', width: '120px' },
            // { id: 'recipe', label: 'RECIPE', width: '120px' }
          ]);
        setStoreList(filteredData);
      }
    }
  }, [productsValue, filter]);

  async function handleCategorySelect(category: any) {
    setSelectedSubCategory(undefined);
    setSelectedProduct(undefined);
    if (category === undefined || category === null) {
      setSelectedCategory(undefined);
      setSelectedProduct(undefined);
      return;
    }

    setSelectedCategory(category);
    await dispatch(
      fetchSubCategories({ page: 1, limit: 5, categoryId: category?._id })
    );
  }

  async function handleSubCategorySelect(subCategory: any) {
    setSelectedProduct(undefined);

    if (subCategory === undefined || subCategory === null) {
      setSelectedProduct(undefined);
      return;
    }

    setSelectedSubCategory(subCategory);
    await dispatch(
      fetchSubCategories({
        page: 1,
        limit: 5,
        categoryId: selectedCategory?._id,
      })
    );
    await dispatch(
      fetchProducts({
        page: 1,
        limit: 5,
        categoryId: selectedCategory?._id,
        subCategoryId: subCategory?._id,
      })
    );
  }

  async function handleProductSelect(product: any) {
    setSelectedProduct(product);
  }

  function productionReportDetailsUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('PRODUCTION_REPORT_DETAILS')}
            menus={
              <>
                <div className="tableOptions">
                  {/* <Button.Print
                            onClick={function(
                              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                            ): void {}}
                          /> */}
                  {/* <Button.Export
                            onClick={function(
                              event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                            ): void {}}
                          /> */}
                </div>
              </>
            }
            //description={f()}
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <BakeasyLargeHeadingValue
              heading={t('PRODUCTION_ID')}
              value={productionId}
            />
          </Grid>
          <Grid container spacing={2} sx={{ alignItems: 'center' }} mt={0.1}>
            {/* <Grid item xs={12} sm={6} md={3} lg={2}>
              <Grid mt={3}>
                <TextField.Search value={''} />{' '}
              </Grid>
            </Grid> */}
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <BakeasyAutoCompleteCategoryA
                value={selectedCategory}
                required={false}
                options={_categoryState.value?.data}
                onChange={(newValue: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    dispatch(
                      fetchCategories({ page: 1, limit: 5, search: newValue })
                    );
                  }

                  if (newValue === null) {
                    dispatch(fetchCategories({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'object') {
                    handleCategorySelect(newValue);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <BakeasyAutoCompleteSubCategoryA
                value={selectedSubCategory}
                required={false}
                options={_subCategoryState.value?.data}
                onChange={(newValue: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  if (typeof newValue === 'string' && newValue?.length === 0) {
                    handleSubCategorySelect(newValue);
                  }

                  if (typeof newValue === 'object') {
                    handleSubCategorySelect(newValue);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={2}>
              <BakeasyAutoCompleteProduct
                value={selectedProduct}
                required={false}
                options={_productsState.value?.data}
                onChange={(newValue: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  handleProductSelect(newValue);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <BakeasySelectNew
                label={t('ORDER_ID')}
                value={selectedOrderId}
                placeholder={t('SELECT') + t('ORDER_ID')}
                disabled={false}
                fullWidth={true}
                size={'small'}
                options={_orderIds?.map((item: any) => item?.orderId)}
                onChange={(e: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  setSelectedOrderId(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Dropdown.ProductReportType
                value={selectedProductionReport}
                required={true}
                onChange={(e: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  setSelectedProductionReport(e.target.value);
                }}
              />
              {/* <BakeasySelectNew
                label={t('PRODUCTION_REPORT')}
                value={selectedProductionReport}
                placeholder={t('SELECT') + t('PRODUCTION_REPORT')}
                disabled={false}
                fullWidth={true}
                size={'small'}
                options={productionReport}
                onChange={(e: any) => {
                  setProductionReportHistory([]);
                  setStoreList([]);
                  setSelectedProductionReport(e.target.value);
                }}
              /> */}
            </Grid>
          </Grid>

          <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
              <Grid marginTop={2}>
                <div className="tableOptions">
                  <BakeasyButton
                    label={t('VIEW_CONSOLIDATED_RECIPE_BUILDER')}
                    onClick={async () => {
                      dispatch(clearProductionReportState());
                      await handleGenerateClick();
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>

          {selectedProductionReport === 'By Product' && (
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12}>
                {productionReportHistory?.length > 0 && (
                  <BakeasyCollapsibleTable
                    reportTableHeaders={reportTableHeaders}
                    tableHeaders={tableHeaders}
                    rowsData={productionReportHistory}
                  />
                )}
              </Grid>
            </Grid>
          )}

          {selectedProductionReport === 'By Store' && (
            <Grid mt={1}>
              {storeList.length > 0 && (
                <BakeasySimpleTable
                  headers={byStoreTableHeaders}
                  tableData={storeList}
                />
              )}
            </Grid>
          )}
        </Paper>
      </Grid>
    );
  }

  return productionReportDetailsUI();
};
